module.exports = __webpack_public_path__ + "media/images/lp/lp28-74494a99c581befea49de5eb878e2e9e.webp";